<template>
  <!-- 活动管理 -->
  <div class="main-container activity-center">
    <div class="content">
      <div class="search-box min">
        <div class="input-item">
          <span class="label">活动时间</span>
          <DatePicker
            v-model="searchParams._createTime"
            type="daterange"
            transfer
            :editable="false"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </div>
        <div class="input-item">
          <span class="label">活动名称</span>
          <Input v-model="searchParams.title" type="text" placeholder="请输入" clearable />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button type="primary" ghost @click="handleReset">重置</Button>
        </div>
      </div>

      <Tabs v-model="searchParams.status" @on-click="onChangeTab">
        <!-- <TabPane label="未开始" name="0" /> -->
        <TabPane label="进行中" name="1" />
        <TabPane label="已结束" name="2" />
      </Tabs>
      <div class="tableBox">
        <loading :isShow="listLoading" />
        <div class="list-wrap">
          <div v-if="tableData && !tableData.length" class="list-empty">暂无数据</div>
          <div v-for="(row, index) in tableData" :key="index" class="list-item">
            <Row>
              <Col :span="8">
                <div class="list-item__left">
                  <div class="list-item__left__title">
                    <span class="icon"></span>
                    <span class="text">{{ row.title || '-' }}</span>
                  </div>
                  <div class="list-item__cell">活动时间：{{ row.startTime | timeFilter }} 至 {{ row.endTime | timeFilter }}</div>
                  <div class="list-item__cell">活动产品：{{ row.productList | productListFilter }}</div>
                </div>
              </Col>
              <Col :span="12">
                <div class="list-item__center">
                  <template v-if="row.type == 1">
                    <!-- 限时加佣 -->
                    <div class="list-item__cell">达标奖励：{{ row | rewardRangeFilter }}</div>
                  </template>
                  <!-- 梯度加佣 -->
                  <template v-else>
                    <div class="list-item__cell rule-title">条件指标：{{ row.conditionRule | conditionRuleFilter }}</div>
                    <div class="list-item__cell" v-for="(item, idx) in row.gradientList" :key="idx">
                      <div class="rule clearfix">
                        <div v-if="item.min && item.max" class="rule-l">达{{ item.min }}美元（含）~ {{ item.max }}美元</div>
                        <div v-else-if="item.min" class="rule-l">达{{ item.min }}美元（含）及以上</div>
                        <!-- 加佣 -->
                        <div v-if="row.rewardType == 1" class="rule-r">奖励{{ item.reward | rewardFilter }}%</div>
                        <!-- 现金 -->
                        <div v-else-if="row.rewardType == 2" class="rule-r" :class="{ last: idx == 2 }">奖励{{ item.reward }}港币</div>
                      </div>
                    </div>
                  </template>
                </div>
              </Col>
              <Col :span="4">
                <div class="list-item__right">
                  <div v-if="row.status == 1" class="list-item__right__time-limit">距离结束还剩：{{ row._endTime }}</div>
                  <div v-if="row.status == 2" class="list-item__right__time-limit done">已结束</div>
                  <div class="list-item__right__btn-box">
                    <Button type="primary" style="height: 36px;width: 125px;" @click="handleViewItem(row)">查看详情</Button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div style="padding-top: 30px;padding-bottom: 20px;">
          <Page
            :total="total"
            :current="pageNum"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 50, 100]"
            show-total
            show-sizer
            style="text-align: center"
            @on-change="getList"
            @on-page-size-change="(pageSize = $event), getList()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lzDicSelect from '@/components/commons/lzDicSelect';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzSelect from '@/components/commons/lzSelect';
import { pageTool, common } from '@/api/mixins';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import Decimal from 'decimal.js';
dayjs.extend(duration);
dayjs.extend(relativeTime);

function getTimeText(endTime) {
  if (!endTime) return '-';
  const now = dayjs();
  const targetTime = dayjs(endTime);

  if (now.isAfter(targetTime)) {
    return '已结束';
  }

  const diff = dayjs.duration(targetTime.diff(now));
  const totalHours = diff.asHours();
  const days = Math.floor(totalHours / 24);
  const hours = Math.floor(totalHours % 24);
  const minutes = diff.minutes();

  let parts = [];
  if (days > 0 || hours > 0) {
    if (days > 0) parts.push(`${days}天`);
    if (hours > 0) parts.push(`${hours}小时`);
  } else if (minutes >= 1) {
    parts.push(`${minutes}分钟`);
  } else {
    parts.push(`0分钟`);
  }

  return parts.join('') || '-';
}

export default {
  mixins: [pageTool, common],
  components: {
    lzSelect,
    lzDicTxt,
    lzDicSelect
  },
  data() {
    return {
      searchParams: {
        status: '1'
      },
      columns: [
        {
          title: '活动ID',
          key: 'id',
          align: 'center',
          width: 200
        },
        {
          title: '活动名称',
          key: 'name',
          align: 'center',
          minWidth: 160
        },
        {
          title: '活动类型',
          key: 'type',
          align: 'center',
          render(h, params) {
            if (!params.row.type) {
              return <span>-</span>;
            } else if (params.row.type == 1) {
              return <span>增员活动</span>;
            } else if (params.row.type == 2) {
              return <span>出单活动</span>;
            } else if (params.row.type == 3) {
              return <span>签约活动</span>;
            }
          },
          width: 100
        },
        {
          title: '活动状态',
          key: 'status',
          align: 'center',
          render(h, params) {
            if (!params.row.status) {
              return <span>-</span>;
            } else if (params.row.status == '0') {
              return <span class="item not-started">未开始</span>;
            } else if (params.row.status == '1') {
              return <span class="item in-progress">进行中</span>;
            } else if (params.row.status == '2') {
              return <span class="item ended">已结束</span>;
            }
          },
          width: 100
        },
        {
          title: '活动开始时间',
          key: 'startTime',
          align: 'center',
          render(h, params) {
            if (!params.row.startTime) {
              return <span>-</span>;
            } else {
              return <div>{params.row.startTime.substring(0, 10)}</div>;
            }
          },
          width: 200
        },
        {
          title: '活动结束时间',
          key: 'endTime',
          align: 'center',
          render(h, params) {
            if (!params.row.endTime) {
              return <span>-</span>;
            } else {
              return <div>{params.row.endTime.substring(0, 10)}</div>;
            }
          },
          width: 200
        },
        {
          title: '参与详情',
          slot: 'HXaO',
          align: 'center',
          width: 100
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          width: 200,
          align: 'center'
        }
      ],
      activityStatusList: [
        { value: 'pSHq', label: '未开始' },
        { value: '1', label: '进行中' },
        { value: '2', label: '已结束' }
      ],
      activityTypeList: [
        { value: 'tmHB', label: '限时加佣' },
        { value: 'velh', label: '梯度加佣' },
        { value: 'pRHY', label: '梯度现金' }
      ]
    };
  },
  filters: {
    productListFilter(arr) {
      if (!arr) return '-';
      if (!arr.length) return '-';
      if (Array.isArray(arr)) {
        if (arr.length > 4) {
          const firstArr = arr.slice(0, 4);
          const secondArr = arr.slice(4);
          if (secondArr.length > 0) {
            return firstArr.join('、') + '等' + arr.length + '个产品';
          }
        }
        return arr.join('、');
      }
      return '-';
    },
    timeFilter(time) {
      if (!time) return '-';
      return dayjs(time).format('YYYY-MM-DD');
    },
    conditionRuleFilter(t) {
      if (t == '1') return '保单规保';
      if (t == '2') return '保单标保';
      if (t == '3') return '累计规保';
      if (t == '4') return '累计标保';
      return '-';
    },
    endTimeFilter(time) {
      return getTimeText(time);
    },
    rewardFilter(reward) {
      if (reward) {
        return new Decimal(reward).mul(100).toNumber();
      } else {
        return reward;
      }
    },
    rewardRangeFilter(row) {
      if (row.rewardMin && row.rewardMax) {
        if (row.rewardMin == row.rewardMax) {
          return `${row.rewardMin}%`;
        }
        return `${row.rewardMin}% ~ ${row.rewardMax}%`;
      } else {
        if (row.rewardMin) {
          return `${row.rewardMin}%`;
        } else if (row.rewardMax) {
          return `${row.rewardMax}%`;
        } else {
          return '-';
        }
      }
    }
  },
  mounted() {
    this.initListParams('/buz/activity/read/list');
  },
  activated() {
    this.getList();
  },
  methods: {
    getLiveTime(row, endTime) {
      const timer = setInterval(() => {
        row._endTime = getTimeText(endTime);
      }, 1000);
      if (!this._timerList) {
        this._timerList = [];
      }
      this._timerList.push(timer);
    },
    isExpired(endTime) {
      const now = dayjs();
      return now.isAfter(dayjs(endTime));
    },
    onChangeTab(tabName) {
      this.listData = [];
      this.searchAjax();
    },
    setListParams(params) {
      if (params._createTime && params._createTime.length) {
        if (params._createTime[0]) {
          params.startTime = dayjs(params._createTime[0]).format('YYYY-MM-DD');
        }
        if (params._createTime[1]) {
          params.endTime = dayjs(params._createTime[1]).format('YYYY-MM-DD');
        }
      }
      delete params._createTime;
    },
    handleViewPartInfo(row) {
      this.$refs.partInfoModal.open(row);
    },
    handleSearch() {
      this.pageNum = 1;
      this.getList();
    },
    handleReset() {
      this.pageNum = 1;
      this.searchParams._createTime = '';
      this.searchParams.title = '';
      this.getList();
    },
    handleEditItem(row) {
      this.$router.push({
        name: 'activityManagerEdit',
        params: {
          id: row.id,
          title: row.title
        }
      });
    },
    handleDelItem(row) {
      this.$notice.inquiry('请问是否要删除此活动，删除后参与数据将会一并删除？').then(() => {
        this.$http({
          url: '/del',
          type: 'GET',
          data: { id: row.id }
        })
          .then(res => {
            if (res.httpCode != 1) {
              this.$notice.msg('操作失败');
              return;
            }
            this.$notice.msg('操作成功');
          })
          .catch(err => {
            console.error(err);
            this.$notice.msg('操作失败');
          });
      });
    },
    handleViewItem(row) {
      this.$router.push({
        name: 'activityManagerDetail',
        query: {
          id: row.id,
          title: row.name,
          backUrl: this.$route.fullPath
        }
      });
    },
    activityChange() {
      vm.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: { companyId: vm.search.companyId }
      }).then(res => {
        vm.productList = res.data;
      });
    },
    listCallback(res) {
      if (this._timerList && this._timerList.length) {
        this._timerList.forEach(timer => {
          clearInterval(timer);
        });
      }
      res.data.forEach(item => {
        item._isExpired = this.isExpired(item.endTime);
        item._endTime = getTimeText(item.endTime);
        if (item.gradientList) {
          item.gradientList.sort((a, b) => {
            return b.min - a.min;
          });
          item.gradientList = item.gradientList.slice(0, 3);
        }
        this.getLiveTime(item, item.endTime);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.activity-center {

  .list-empty {
    padding-top: 300px;
    padding-bottom: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    padding-right: 30px;
    color: #898989;
  }

  .tableBox {
    padding-left: 30px;
    padding-right: 30px;
    min-width: 930px;
    .list-item {
      font-family: PingFang SC, ' PingFang SC';
      padding-top: 30px;
      padding-bottom: 17px;
      border-bottom: 1px solid #ececec;

      .list-item__cell {
        margin-top: 10px;
      }

      .list-item__left {
        padding-right: 20px;
        .list-item__left__title {
          display: flex;
          // align-items: center;
          min-height: 22px;
          .icon {
            display: inline-block;
            height: 18px;
            width: 18px;
            margin-top: 2px;
            background-image: url('./clock.png');
            background-repeat: no-repeat;
            background-size: contain;
            margin-right: 4px;
          }
          .text {
            font-weight: 500;
            font-size: 16px;
            color: #3c464f;
            line-height: 18px;
          }
        }
      }

      .list-item__center {
        padding-left: 40px;
        .list-item__cell:first-child {
          margin-top: 0;
        }

        &.rule-title {
          padding-left: 0;
        }
        .rule {
          display: flex;
          padding-left: 0;
          @media screen and (min-width: 1280px) {
            .rule-r{
              width: 50%;
              padding-left: 40px;
            }
          }
          .rule-l {
            min-width: 240px;
            float: left;
          }
          .rule-r {
            min-width: 200px;
            float: right;
            &.last {
              &::after {
                content: '...';
              }
            }
          }
        }
      }

      .list-item__right {
        text-align: right;
        .list-item__right__time-limit {
          height: 20px;
          font-weight: 400;
          font-size: 14px;
          color: #f59045;
          line-height: 20px;
          white-space: nowrap;
          text-align: right;
          float: right;

          &.done {
            color: #727c8e;
          }
        }

        .list-item__right__btn-box {
          padding-top: 30px;
        }
      }
    }
  }
}
</style>
